import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Chart, ChartType } from 'chart.js';
import { endOfMonth, startOfMonth } from 'date-fns';
import { Dashboard } from '../models/dashboard.interface';
import { COLORS } from '../themes/dashboard.colors';
import { ReporteHorasDetalle } from '../models/informes.types';

@Injectable()
export class ChartsService {
  chart1: Chart;
  chart3: Chart;
  chart2: Chart;
  chart4: Chart;

  simboloMoneda='';

  filterChart = 1;

  formattedInicio = startOfMonth(new Date()).toString();
  formattedFin = endOfMonth(new Date()).toString();

  colors = COLORS;

  constructor() {}

  createChart(dashboard: Dashboard, mainFilter: number) {
    const canvas = document.getElementById(
      'ingresos-diarios'
    ) as HTMLCanvasElement;
    const ctx2 = canvas?.getContext('2d');
    const gradient = ctx2.createLinearGradient(0, 0, 0, 350);
    gradient.addColorStop(0, 'rgba(82, 186, 225, 0.2)');
    gradient.addColorStop(1, 'rgba(82, 186, 225, 0)');

    this.chart1 = new Chart('ingresos-diarios', {
      type: 'line' as ChartType,
      data: {
        datasets: [
          {
            backgroundColor: gradient,
            borderColor: '#52BAE1',
            borderWidth: 1,
            data: dashboard.Ventas.map((ventas) => ventas.Total),
            fill: true,
          },
        ],
        labels: dashboard.Ventas.map((ventas) =>
          this.formatDate(new Date(ventas.Fecha))
        ),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          axis: 'xy',
          intersect: false,
          mode: 'nearest',
        },
        locale: 'es-US',
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            bodyColor: '#545454',
            bodyFont: {
              family: 'Lufga',
            },
            borderColor: 'rgba(84, 84, 84, 0.2)',
            borderWidth: 1,
            callbacks: {
               label: ({ formattedValue }) => `${this.simboloMoneda} ${formattedValue}`,
              title: () => '',
            },
            displayColors: false,
            titleColor: '#545454',
            yAlign: 'bottom',
          },
        },
        scales: {
          y: {
            grid: {
              borderDash: [8, 4],
            },
            ticks: {
              font: {
                family: 'Lufga',
              },
            },
          },
          x: {
            grid: {
              borderDash: [8, 4],
              display: false,
            },
            ticks: {
              font: {
                family: 'Lufga',
              },
            },
          },
        },
      },
      plugins: [
        {
          id: 'ingresos-diarios',
          afterDraw: (chart) => {
            if (chart.data.datasets[0].data.length === 0) {
              const ctx = chart.ctx;
              const width = chart.width;
              const height = chart.height;
              // chart.clear();

                            ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#808080';
              ctx.font = window.innerWidth < 768 ? '10px Lufga' : '18px Lufga';
              const lineHeight = window.innerWidth < 768 ? 15 : 25;
              const message1 = 'No hay ingresos registrados';
              const message2 = window.innerWidth < 768 ? 'Aquí verás información\nsobre las ventas que has realizado' : 'Aquí verás información sobre las ventas que has realizado';
              ctx.fillText(message1, width / 2, height / 3);
              const lines = message2.split('\n');
              lines.forEach((line, i) => {
                ctx.fillText(line, width / 2, height / 2 + (i * lineHeight));
              });
              ctx.restore();
            }
          },
        }
      ],
    });

    this.chart2 = new Chart('tipo-pedidos', {
      type: 'pie' as ChartType,
      data: {
        datasets: [
          {
            backgroundColor: this.colors,
            data: dashboard.TipoPedidos.map((pedidos) => pedidos.Lempiras),
          },
        ],
        labels: dashboard.TipoPedidos.map((pedidos) => pedidos.TipoPedido),
      },
      options: {
        maintainAspectRatio: false,
        aspectRatio: 2,
        locale: 'es-US',
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
            },
            position: 'bottom',
          },
          tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            bodyColor: '#545454',
            bodyFont: {
              family: 'Lufga',
            },
            borderColor: 'rgba(84, 84, 84, 0.2)',
            borderWidth: 1,
            callbacks: {
               label: ({ formattedValue }) => `${this.simboloMoneda} ${formattedValue}`,
              title: () => '',
            },
            displayColors: false,
            titleColor: '#545454',
            yAlign: 'bottom',
          },
        },
      },
      plugins: [
        {
          id: 'tipo-pedidos',
          afterDraw: (chart) => {
            if (chart.data.datasets[0].data.length === 0) {
              const ctx = chart.ctx;
              const width = chart.width;
              const height = chart.height;
              // chart.clear();

              ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = window.innerWidth < 768 ? '11px Lufga' : '18px Lufga';
              ctx.fillStyle = '#808080';
              ctx.fillText(
                'No hay suficientes datos para mostrar',
                width / 2,
                height / 2
              );
              ctx.restore();
            }
          },
        },
      ],
    });

    this.chart3 = new Chart('metodos-pago', {
      type: 'pie' as ChartType,
      data: {
        datasets: [
          {
            backgroundColor: this.colors,
            data: dashboard.FormasPago.map((formas) => formas.Valor),
          },
        ],
        labels: dashboard.FormasPago.map((formas) => formas.NombreFormaPago),
      },
      options: {
        maintainAspectRatio: false,
        aspectRatio: 2,
        locale: 'es-US',
        plugins: {
          legend: {
            labels: {
              usePointStyle: true,
            },
            position: 'bottom',
          },
          tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            bodyColor: '#545454',
            bodyFont: {
              family: 'Lufga',
            },
            borderColor: 'rgba(84, 84, 84, 0.2)',
            borderWidth: 1,
            callbacks: {
               label: ({ formattedValue }) => `${this.simboloMoneda} ${formattedValue}`,
              title: () => '',
            },
            displayColors: false,
            titleColor: '#545454',
            yAlign: 'bottom',
          },
        },
      },
      plugins: [
        {
          id: 'metodos-pago',
          afterDraw: (chart) => {
            if (chart.data.datasets[0].data.length === 0) {
              const ctx = chart.ctx;
              const width = chart.width;
              const height = chart.height;
              // chart.clear();

              ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = window.innerWidth < 768 ? '11px Lufga' : '18px Lufga';
              ctx.fillStyle = '#808080';
              ctx.fillText(
                'No hay suficientes datos para mostrar',
                width / 2,
                height / 2
              );
              ctx.restore();
            }
          },
        },
      ],
    });

    this.chart4 = new Chart('ingresos-categoria', {
      type: 'bar' as ChartType,
      data: {
        datasets: [
          {
            backgroundColor: this.colors,
            barPercentage: 0.25,
            borderRadius: 10,
            data: dashboard.Categorias.map((categorias) => categorias.Lps),
          },
        ],
        labels: dashboard.Categorias.map(
          (categorias) => categorias.NombreCategoriaProducto
        ),
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          axis: 'xy',
          intersect: false,
          mode: 'nearest',
        },
        locale: 'es-US',
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            backgroundColor: 'rgba(255, 255, 255, 1)',
            bodyColor: '#545454',
            bodyFont: {
              family: 'Lufga',
            },
            borderColor: 'rgba(84, 84, 84, 0.2)',
            borderWidth: 1,
            callbacks: {
               label: ({ formattedValue }) => `${this.simboloMoneda} ${formattedValue}`,
              title: () => '',
            },
            displayColors: false,
            titleColor: '#545454',
            yAlign: 'bottom',
          },
        },
        scales: {
          y: {
            grid: {
              borderDash: [8, 4],
            },
            ticks: {
              font: {
                family: 'Lufga',
              },
            },
          },
          x: {
            grid: {
              borderDash: [8, 4],
              display: false,
            },
            ticks: {
              font: {
                family: 'Lufga',
              },
            },
          },
        },
      },
      plugins: [
        {
          id: 'ingresos-diarios',
          afterDraw: (chart) => {
            if (chart.data.datasets[0].data.length === 0) {
              const ctx = chart.ctx;
              const width = chart.width;
              const height = chart.height;
              // chart.clear();

              ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = window.innerWidth < 768 ? '10px Lufga' : '18px Lufga';
              ctx.fillStyle = '#808080';
              const lineHeight = window.innerWidth < 768 ? 15 : 25;
              const message1 = 'No hay suficientes datos';
              const message2 = window.innerWidth < 768 ? 'Aquí verás las categorías\nde productos que más vendes' : 'Aquí verás las categorías de productos que más vendes';
              ctx.fillText(message1, width / 2, height / 4);
              const lines = message2.split('\n');
              lines.forEach((line, i) => {
                ctx.fillText(line, width / 2, height / 2 + (i * lineHeight));
              });
              ctx.restore();
            }
          },
        },
      ],
    });

    if (this.formattedInicio === this.formattedFin) {
      this.filterChart = 2;
      this.changeChartFilter(dashboard, mainFilter);
    }
  }

  changeChartFilter(dashboard: Dashboard, mainFilter: number) {
    const data1 = this.chart1.data.datasets[0];
    const label1 = this.chart1.options.plugins.tooltip.callbacks;
    if (this.filterChart === 1) {
      if (mainFilter === 1) {
        label1.label = ({ formattedValue }) =>  `${this.simboloMoneda}  ${formattedValue}`;
        data1.data = dashboard.Ventas.map((ventas) => ventas.Total);
        this.chart1.data.labels = dashboard.Ventas.map((ventas) =>
          this.formatDate(new Date(ventas.Fecha))
        );
      } else {
        label1.label = ({ formattedValue }) => formattedValue;
        data1.data = dashboard.Ventas.map((ventas) => ventas.Cantidad);
        this.chart1.data.labels = dashboard.Ventas.map((ventas) =>
          this.formatDate(new Date(ventas.Fecha))
        );
      }
      this.updateChart();
    } else {
      if (mainFilter === 1) {
        label1.label = ({ formattedValue }) =>  `${this.simboloMoneda} ${formattedValue}`;
        data1.data = dashboard.VentasXHora.map(
          (ventas) => ventas.Total / ventas.Cantidad
        );
        this.chart1.data.labels = dashboard.VentasXHora.map(
          (ventas) => ventas.Hora
        );
      } else {
        label1.label = ({ formattedValue }) => formattedValue;
        data1.data = dashboard.VentasXHora.map((ventas) => ventas.Cantidad);
        this.chart1.data.labels = dashboard.VentasXHora.map(
          (ventas) => ventas.Hora
        );
      }
      this.updateChart();
    }
  }

  private updateChart() {
    this.chart1.update();
  }

  formatDate(date: Date) {
    const formattedDate = formatDate(date, 'd MMM', 'es');
    return formattedDate;
  }
}
